import { supportedLanguages } from '../i18n';

export const projectStatuses = [
  'draft',
  'intake',
  'interview_planned',
  'interview_in_progress',
  'transcription_in_progress',
  'story_outline_in_progress',
  'story_writing_in_progress',
  'review_in_progress',
  'design_in_progress',
  'approval_pending',
  'publishing_in_progress',
  'completed',
  'on_hold',
  'cancelled',
];

export const storyTypes = [
  { value: 'life_book', label: 'Life or Legacy Book' },
  { value: 'family_book', label: 'Family Book' },
  { value: 'community_book', label: 'Community Book' },
  { value: 'cookbook', label: 'Cookbook' },
  { value: 'picture_book', label: 'Picture Book' },
  { value: 'video_clip', label: 'Video Clip' },
  { value: 'presentation', label: 'Presentation' },
];

export const packageTypes = [
  { value: 'self_service', label: 'Self Service' },
  { value: 'guided', label: 'Guided' },
  { value: 'full_service', label: 'Full Service' },
];

export const languageOptions = [
  {
    value: 'en',
    locale: supportedLanguages.en.locale,
    direction: supportedLanguages.en.direction,
    label: supportedLanguages.en.nativeName,
  },
  {
    value: 'es',
    locale: supportedLanguages.es.locale,
    direction: supportedLanguages.es.direction,
    label: supportedLanguages.es.nativeName,
  },
  {
    value: 'he',
    locale: supportedLanguages.he.locale,
    direction: supportedLanguages.he.direction,
    label: supportedLanguages.he.nativeName,
  },
  {
    value: 'ja',
    locale: supportedLanguages.ja.locale,
    direction: supportedLanguages.ja.direction,
    label: supportedLanguages.ja.nativeName,
  },
];

export const projectRoles = [
  { value: 'project_manager', label: 'Project Manager' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'service_provider', label: 'Service Provider' },
  { value: 'interviewer', label: 'Interviewer' },
  { value: 'writer', label: 'Writer' },
  { value: 'designer', label: 'Designer' },
  { value: 'reviewer', label: 'Reviewer' },
  { value: 'interviewee', label: 'Interviewee' },
];

export const formatLabel = (value?: string | null): string => {
  if (!value) {
    return 'Not set';
  }
  return value
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getStatusColor = (status: string): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  if (
    status === 'completed' ||
    status === 'approved' ||
    status === 'active' ||
    status === 'resolved' ||
    status === 'publishing_ready'
  ) {
    return 'success';
  }
  if (status === 'cancelled' || status === 'rejected' || status === 'deactivated') {
    return 'error';
  }
  if (
    status === 'on_hold' ||
    status === 'approval_pending' ||
    status === 'open' ||
    status === 'changes_requested' ||
    status.includes('review')
  ) {
    return 'warning';
  }
  if (status.includes('progress') || status.includes('planned') || status === 'intake' || status === 'design_ready') {
    return 'info';
  }
  return 'default';
};
